module.exports = __webpack_public_path__ + "img/lens-167-minus-08.07056779.png";